import i18n from '../translation'
import _ from 'lodash'
import { LEVEL, DOMAINE } from '../constants'
import axios from 'axios'
// import { data } from 'autoprefixer'

export const _User = {
  namespaced: true,
  state: {
    // listeMessages: [],
    remainingSteps: '',
    installProgress: 0,
    ongoingTuto: false,
    tutoQuited: false,
    isMobile: false,
    isMobileIOS: false,
    expertMode: false,
    optionAffichage1: false,
    optionAffichage2: false,
    optionAffichage3: false,
    editWatson: 0,
    configured: '0'
  },
  getters: {
    user: state => state,
    fullName: state => _.trim(state.fname + ' ' + state.lname),
    userAvatar: state => {
      if (state.avatar) {
        if (process.env.NODE_ENV === 'development') {
          return `${DOMAINE}/dev/media/user/small/${state.avatar}`
        } else {
          return `${DOMAINE}/media/user/small/${state.avatar}`
        }
      }
      return null
    },
    account: state => {
      switch (parseInt(state.rights)) {
        case 0:
          return {
            type: i18n.messages[i18n.locale]['accountAgent'],
            role: 'peon',
            rights: parseInt(state.rights)
          }
        case 1:
          return {
            type: i18n.messages[i18n.locale]['accountAgent'],
            role: 'agent',
            rights: parseInt(state.rights)
          }
        case 2:
          return {
            type: i18n.messages[i18n.locale]['accountSuper'],
            role: 'super',
            rights: parseInt(state.rights)
          }
        case 3:
          return {
            type: i18n.messages[i18n.locale]['accountAdmin'],
            role: 'admin',
            rights: parseInt(state.rights)
          }
        case 999:
          return {
            type: i18n.messages[i18n.locale]['accountAdminTf'],
            role: 'adminTF',
            rights: parseInt(state.rights)
          }
        default:
          return {
            type: i18n.messages[i18n.locale]['accountUnknown'],
            role: null,
            rights: parseInt(state.rights)
          }
      }
    },
    level: state => {
      let level = parseInt(state.entLevel)
      switch (level) {
        case LEVEL.HS:
          return {
            title: i18n.messages[i18n.locale]['levelHS'],
            rights: level,
            monitor: 0
          }
        case LEVEL.ESSAI:
          return {
            title: i18n.messages[i18n.locale]['levelEssai'],
            rights: level,
            monitor: 20000
          }
        case LEVEL.START:
          return {
            title: 'Start',
            rights: level,
            monitor: 45000
          }
        case LEVEL.CHAT:
          return {
            title: 'ChatFirst',
            rights: level,
            monitor: 0
          }
        case LEVEL.PRO:
          return {
            title: 'Pro',
            rights: level,
            monitor: 30000
          }
        case LEVEL.ENTREPRISE:
          return {
            title: 'Entreprise',
            rights: level,
            monitor: 20000
          }
        case LEVEL.FAQ:
          return {
            title: 'Faq',
            rights: level,
            monitor: 20000
          }
        default:
          return null
      }
    },
    /**
     * Retourne la liste des conseillers sans moi
     */
    colleaguesWithoutMe: state => {
      return _.filter(state.colleagues, function (u) { return u.USR_ID !== state.id })
    },
    /**
     * Retourne la liste des bots sans moi
     */
    botsWithoutMe: state => {
      return _.filter(state.bots, function (u) { return u.USR_ID !== state.id })
    },
    getUserById: state => id => {
      const userId = Number.parseInt(id)
      return state.colleagues.find(c => Number.parseInt(c.USR_ID) === userId)
    },
    ketb: state => state.ketb
  },
  mutations: {
    setUser (state, newUser) {
      state.id = newUser.id
      state.fname = newUser.fname
      state.lname = newUser.lname
      state.mail = newUser.mail
      state.mailContact = newUser.mailContact
      state.job = newUser.job
      state.phone = newUser.phone
      state.ios = newUser.ios
      state.title = newUser.title
      state.avatar = newUser.avatar
      state.entLevel = newUser.entLevel
      state.licSpecialtable = newUser.licSpecialtable
      state.entSF = newUser.entSF
      state.entSY = newUser.entSY
      state.entSYV2 = newUser.entSYV2
      state.entSYCustom = newUser.entSYCustom
      state.entZD = newUser.entZD
      state.entGA = newUser.entGA
      state.entSlack = newUser.entSlack
      state.apz = newUser.apz
      state.whatsapp = newUser.whatsapp
      state.webhook = newUser.webhook
      state.user_sites = newUser.user_sites
      state.smsOn = newUser.smsOn
      // state.autoAnswser = newUser.autoAnswser
      // lang à synchro avec le module de lang
      state.lang = newUser.lang
      i18n.locale = newUser.lang
      // EXCEPTIONS CLIENTS
      // KAUFMAN KetB
      state.ketb = newUser.ketb
    },
    setAvatar (state, newAvatar) {
      state.avatar = newAvatar
        ? newAvatar + '?' + Math.random()
        : null
    },
    setEntNbPageTotal (state, nb) {
      state.entNbPageTotal = nb
    },
    addColleague (state, colleague) {
      state.colleagues.push(colleague)
    },
    // -------------------------------------------------------------
    // enregistre le bot selectionné
    // -------------------------------------------------------------
    SET_SELECTEDBOT (state, data) {
      // console.log('SET_SELECTEDBOT', data)
      state.botSelected = data
    },
    // -------------------------------------------------------------
    // enregistre le mode expert de l'utilisateur
    // -------------------------------------------------------------
    SET_EXPERTMODE (state, data) {
      // console.log('SET_EXPERTMODE', data)
      state.expertMode = data
    },
    // -------------------------------------------------------------
    // enregistre option affichage 1
    // -------------------------------------------------------------
    SET_AFF_OPTION_1 (state, data) {
      // console.log('SET_AFF_OPTION_1', data)
      state.optionAffichage1 = data
    },
    // -------------------------------------------------------------
    // enregistre option affichage 2
    // -------------------------------------------------------------
    SET_AFF_OPTION_2 (state, data) {
      // console.log('SET_AFF_OPTION_2', data)
      state.optionAffichage2 = data
    },
    // -------------------------------------------------------------
    // enregistre option affichage 3
    // -------------------------------------------------------------
    SET_AFF_OPTION_3 (state, data) {
      // console.log('SET_AFF_OPTION_3', data)
      state.optionAffichage3 = data
    },
    // -------------------------------------------------------------
    // enregistre le device de l'utilisateur
    // -------------------------------------------------------------
    SET_ISMOBILE (state, data) {
      // console.log('SET_ISMOBILE', data)
      state.isMobile = data
    },
    // -------------------------------------------------------------
    // enregistre si l'utilisateur est sur ios
    // -------------------------------------------------------------
    SET_ISMOBILEIOS (state, data) {
      // console.log('SET_ISMOBILEIOS', data)
      state.isMobileIOS = data
    },
    // -------------------------------------------------------------
    // modification du contenu du tableau colleagues
    // -------------------------------------------------------------
    SET_COLLEAGUE_ADD_LISTEMESSAGES (state) {
      // console.log('SET_COLLEAGUE_ADD_LISTEMESSAGES', state.id)
      state.colleagues.forEach(function (element) {
        // si il y a deja une liste de messages en attentes
        if (element.listeMessages) {
          // console.log('liste message', element)
          // si il n'y a pas de liste de messages en attentes
        } else {
          // i c'est moi
          if (element.USR_ID === state.id) {
            // console.log('moi')
            // ajoute la liste déjà existante dans _user
            element.listeMessages = state.listeMessages
          } else {
            console.log('pas moi', element)
            // sinon création d'un tableau vide pour le remplire apres
            element.listeMessages = []
          }
        }
      })
    },
    // -------------------------------------------------------------
    // MISE A JOUR DE LA LISTE DES MESSAGES EN ATTENTES DES COLLEGUES
    // -------------------------------------------------------------
    SET_COLLEAGUE_MESSAGE_ATTENTE (state, data) {
      // console.log('SET_COLLEAGUE_MESSAGE_ATTENTE', data)
      // purge les tableaux de message avant de les remplir à nouveau
      _.forEach(
        data.agentId,
        (agent, key) => {
          // pour chaque agent dans la liste, il faut effacer sont tableau de message en attente
          let index = _.findIndex(state.colleagues, function (o) { return Number.parseInt(o.USR_ID) === Number.parseInt(agent) })
          if (index !== -1) {
            // console.log('id agent', agent)
            // vide les messages des agents
            state.colleagues[index].listeMessages = []
          } else {
            // console.log('aucun agent trouvé')
          }
        }
      )
      // console.log('SET_COLLEAGUE_MESSAGE_ATTENTE', data.liste)
      // state.colleagues.find(c => Number.parseInt(c.USR_ID) === liste[0].agentId)
      _.forEach(
        data.liste,
        (messageAttente, key) => {
          // pour chaque message on recherche l'agent correspondant dans la liste des agents
          let indexAgent = _.findIndex(state.colleagues, function (o) { return Number.parseInt(o.USR_ID) === Number.parseInt(messageAttente.agentId) })
          // si un agent corespond a celui du message en attente
          if (indexAgent !== -1) {
            // il faut maintenant regarder si ce message n'est pas deja dans la liste
            let indexMessage = _.findIndex(state.colleagues[indexAgent].listeMessages, function (o) { return Number.parseInt(o.timestamp) === Number.parseInt(messageAttente.timestamp) })
            // si aucuns doublons trouvés
            if (indexMessage === -1) {
              // console.log('pas de double')
              // on ajoute ce message dans la liste
              state.colleagues[indexAgent].listeMessages.push(messageAttente)
            }
          } else {
            // console.log('aucun agent trouvé')
          }
        }
      )
      // console.log('SET_MESSAGE_ATTENTE', liste)
      // state.listeMessages = liste
    },
    // -------------------------------------------------------------
    // EFFACE DES MESSAGES EN ATTENTE
    // -------------------------------------------------------------
    SET_DEL_MESSAGE_ATTENTE (state, data) {
      // console.log('SET_DEL_MESSAGE_ATTENTE', data)
      let index = _.findIndex(state.colleagues, function (o) { return Number.parseInt(o.USR_ID) === Number.parseInt(data.agentId) })
      if (index !== -1) {
        // console.log('add liste message')
        state.colleagues[index].listeMessages = data.liste
      } else {
        // console.log('aucun agent trouvé')
      }
      // console.log('SET_MESSAGE_ATTENTE', liste)
      // state.listeMessages = liste
    },
    // -------------------------------------------------------------
    // MISE A JOUR DE LA LISTE DES MESSAGES EN ATTENTES
    // -------------------------------------------------------------
    SET_MESSAGE_ATTENTE (state, liste) {
      // console.log('SET_MESSAGE_ATTENTE', liste)
      // console.log('set visiteur', visiteur)
      // console.log('SET_MESSAGE_ATTENTE', liste)
      // state.listeMessages = liste
    },
    // -------------------------------------------------------------
    // AJOUTE UN MESSAGES EN ATTENTES DANS LA LISTE
    // -------------------------------------------------------------
    SET_ADD_MESSAGE_ATTENTE (state, message) {
      // console.log('SET_ADD_MESSAGE_ATTENTE', message)
      // let messagesList = state.listeMessages
      let newMessageAttente
      let agentId
      let timestamp
      // si c'est un message facebook
      if (message.network === 'facebook') {
        newMessageAttente = {
          'AR': 0,
          'CHAT_SESSION': '0',
          'agentId': Number.parseInt(message.agentID),
          'attachments': message.attachments,
          'entrepriseId': message.entrepriseID,
          'profile_pic': message.dataVisiteur.profile_pic,
          'filterID': '0',
          'lu': 0,
          'message': [message.message],
          'messageId': '',
          'network': message.network,
          'roomName': '',
          'siteID': message.siteID,
          'tags': '',
          'timestamp': Math.floor(message.time / 1000),
          'visiteurID': message.senderID,
          'visiteurName': message.dataVisiteur.first_name + ' ' + message.dataVisiteur.last_name
        }
        agentId = message.agentID
        timestamp = newMessageAttente.timestamp
        // si c'est un message whatsapp
      } else if (message.network === 'whatsapp') {
        newMessageAttente = {
          'AR': 0,
          'CHAT_SESSION': '0',
          'agentId': Number.parseInt(message.agentID),
          'attachments': message.attachments,
          'entrepriseId': message.entrepriseID,
          // 'profile_pic': message.dataVisiteur.profile_pic,
          'filterID': '0',
          'lu': 0,
          'message': [message.message],
          'messageId': '',
          'network': message.network,
          'roomName': '',
          'siteID': message.siteID,
          'tags': '',
          'timestamp': Math.floor(message.time / 1000),
          'visiteurID': message.senderID,
          'visiteurName': message.nameAuteur
        }
        agentId = message.agentID
        timestamp = newMessageAttente.timestamp
        // messages sur le network moon ou autre
      } else {
        // il manque le messageId si je recupère directement les données du message
        newMessageAttente = {
          'AR': 0,
          'CHAT_SESSION': '0',
          'agentId': message.WZAgentId,
          'attachments': '',
          'entrepriseId': message.entrepriseId,
          'filterID': '0',
          'lu': message.read,
          'message': [message.message],
          'messageId': '',
          'network': message.network,
          'roomName': message.chatSession,
          'siteID': message.siteId,
          'tags': message.tags,
          'timestamp': message.timeStamp,
          'visiteurID': message.chatSession,
          'visiteurName': message.chatSession
        }
        agentId = message.WZAgentId
        timestamp = message.timeStamp
      }

      // console.log('newMessageAttente', newMessageAttente)
      /*
      // si ce sont des message pour moi il faut aussi mettre à jour la liste des message en attente dans _User
      if (Number.parseInt(agentId) === Number.parseInt(state.id)) {
        let indexMessage = _.findIndex(state.listeMessages, function (o) { return Number.parseInt(o.timestamp) === Number.parseInt(timestamp) })
        if (indexMessage !== -1) {
          // console.log('ce message est deja dans la liste')
        } else {
          // console.log('add message')
          state.listeMessages.push(newMessageAttente)
        }
      }

      */
      // messagesList.push(newMessageAttente)
      // console.log('messagesList', messagesList)
      // il faut aussi mettre à jour la liste dans le tableau colleagues
      let index = _.findIndex(state.colleagues, function (o) { return Number.parseInt(o.USR_ID) === Number.parseInt(agentId) })
      // console.log('index', index)
      if (index !== -1) {
        // console.log('add liste message')
        let indexMessage = _.findIndex(state.colleagues[index].listeMessages, function (o) { return Number.parseInt(o.timestamp) === Number.parseInt(timestamp) })
        if (indexMessage !== -1) {
          // console.log('ce message est deja dans la liste messageAttente agent')
        } else {
          // console.log('add message colleagues')
          state.colleagues[index].listeMessages.push(newMessageAttente)
        }
        // console.log('state.colleagues[index].listeMessages', state.colleagues[index].listeMessages)
      } else {
        // console.log('aucun agent trouvé')
      }
      // console.log('SET_MESSAGE_ATTENTE', liste)
      // state.listeMessages = liste

      // Si cette conversation est ouverte dans contact
      // il faut mettre aussi à jour l'histochat du contact ouvert
    },
    // -------------------------------------------------------------
    // MISE A JOUR DE L'AVATAR DE LA LISTE DES MESSAGES EN ATTENTES
    // -------------------------------------------------------------
    SET_AVATAR_MESSAGE_ATTENTE (state, data) {
      // console.log('SET_AVATAR_MESSAGE_ATTENTE', data)
      let index = _.findIndex(state.colleagues, function (o) {
        return Number.parseInt(o.USR_ID) === Number.parseInt(data.agentId)
      })
      if (index !== -1) {
        state.colleagues[index].listeMessages.splice(data.key, 1, data.visiteurData)
      }
      // state.listeMessages.splice(data.key, 1, data.visiteurData)
      // state.listeMessages = liste
    },
    // -------------------------------------------------------------
    // MISE A JOUR DU CAPTCHA
    // -------------------------------------------------------------
    SET_CONFIGURED (state, data) {
      state.configured = data
    },
    // -------------------------------------------------------------
    // MISE A JOUR dDE LA PROGRESSION DE L'UTILISATION DU BO PAR LE CONSEILLER
    // -------------------------------------------------------------
    MAJ_PROGRESSION (state, data) {
      // console.log('MAJ_PROGRESSION', data)
      state.remainingSteps = data.remainingSteps
      state.installProgress += data.installProgress
    },
    // -------------------------------------------------------------
    // LE CONSEILLER EST OU N'EST PAS DANS LE TUTO
    // -------------------------------------------------------------
    ONGOING_TUTO (state, data) {
      state.ongoingTuto = data.ongoingTuto
    },
    // -------------------------------------------------------------
    // LE CONSEILLER QUITTE LE TUTO
    // -------------------------------------------------------------
    QUIT_TUTO (state, data) {
      state.tutoQuited = data.tutoQuited
    },
    // -------------------------------------------------------------
    // LE CONSEILLER A ENVOYE UNE MODIF DANS WATSON
    // -------------------------------------------------------------
    RELOAD_WATSON (state, data) {
      state.editWatson = data.editWatson
    },
    // -------------------------------------------------------------
    // ON MET A JOUR LA LISTE DES BOTS
    // -------------------------------------------------------------
    UPDATE_BOT_LIST (state, data) {
      state.bots = data.list
    }
    // -------------------------------------------------------------
    // création de la liste des messages en attente
    // -------------------------------------------------------------
    /*
    SET_COLLEAGUES_MESSAGE_ATTENTE (state, data) {
      console.log('SET_COLLEAGUES_MESSAGE_ATTENTE', this.state)
      console.log('SET_COLLEAGUES_MESSAGE_ATTENTE data', data)
      // ajoute dans chaque agent un object messageAttente vide
      // mise à jours de mes messages en attente
      // console.log('state.colleagues', state.colleagues)
      let index = _.findIndex(this.state._User.colleagues, function (o) {
        // console.log('o', o)
        return Number.parseInt(o.USR_ID) === Number.parseInt(data.agentId)
      })
      console.log('index', index)
      if (index !== -1) {
        console.log('add liste message')
        this.state._User.colleagues[index].listeMessages = data.listeMessages.data
        // parse le tableau pour trouve le visiteur qui vient d'un reseau social
        _.forEach(
          this.state._User.colleagues[index].listeMessages,
          (allVisiteurs, key) => {
            if (allVisiteurs.network === 'facebook') {
              let dataVisiteur = {
                'visiteurData': allVisiteurs,
                'key': key,
                'agentId': data.agentId
              }
              this.dispatch('_User/GET_AVATAR_FACEBOOK', dataVisiteur)
              // let dataVisiteur = {'visiteurData': allVisiteurs, 'key': key}
              // console.log('visiteur facebook : ', allVisiteurs.visiteurName)
              // let dataVisiteur = {'visiteurData': allVisiteurs, 'key': key}
              // this.getAvatarVisiteur(dataVisiteur)
              // console.log('listeMessages key ', key)
            }
          }
        )
      } else {
        console.log('aucun agent trouvé')
      }
    }
    */
  },

  actions: {
    GET_AVATAR_FACEBOOK (context, data) {
      // console.log('GET_AVATAR_FACEBOOK', context)
      // console.log('GET_AVATAR_FACEBOOK data', data)
      axios.get(
        'get/chats_abscence_avatar.php?visitorId=' +
        data.visiteurData.visiteurID
      )
        .then(response => {
          // console.log('response', response.data)
          if (response.data) {
            // return response.data
            data.visiteurData.profile_pic = response.data
            // let messagesList = _.cloneDeep(this.$store.state._User.user.listeMessages)
            // messagesList.splice(data.key, 1, data.visiteurData) // change l'etat du over sur le drop
            context.commit('SET_AVATAR_MESSAGE_ATTENTE', data)
            // console.log('this.listeMessages', this.user.listeMessages)
          }
        })
        .catch(_ => {
          // window.alert('totejfojiz ezuihf uihezhf uihs of uge')
        })
        .then(_ => {
        })
    },
    // -------------------------------------------------------------
    // modification du contenu du tableau colleagues
    // -------------------------------------------------------------
    GET_COLLEAGUE_LISTEMESSAGES (context, agentId) {
      // console.log('GET_COLLEAGUE_LISTEMESSAGES 1', state)
      // passe à la requete
      axios.get(
        'get/chats_abscence.php?agentId=' +
        agentId
      )
        .then(response => {
          console.log('response', response)
          context.commit('SET_COLLEAGUE_MESSAGE_ATTENTE', {
            'liste': response.data,
            'agentId': agentId
          })
          return new Promise((resolve, reject) => {
            resolve(response)
          })
        })
        .catch(_ => {
          // window.alert('totejfojiz ezuihf uihezhf uihs of uge')
        })
        .then(_ => {
        })
    },
    /**
     * Reception d'un message visiteur envoyé directement à un agent
     * @param  {Object} message [description]
     */
    socket_updatechatClient: (context, message) => {
      // console.log('socket_updatechatClient', message)
      // il faut stocker le message dans les messages en attente
      // uniquement si l'agent est offline ou occupé
      // console.log('socket_updatechatClient', context.rootState._StoreWatcheeBox.status)
      if (context.rootState._StoreWatcheeBox.status !== 'online') {
        // uniquement si c'est un message visiteur
        if (message.data.auteur === 'Visiteur') {
          context.commit('SET_ADD_MESSAGE_ATTENTE', message.data) // mise à jour de la liste des messages en attente
        }
      }
    },
    /**
     * Reception d'un message visiteur envoyé à un agent indispo (message attente)
     * @param  {Object} message [description]
     */
    socket_updateMessageAttenteClient: (context, message) => {
      // console.log('socket_updateMessageAttenteClient', context)
      // console.log('socket_updateMessageAttenteClient', message)
      // uniquement si super agent ou plus
      if (context.state.rights !== '0' && context.state.rights !== '1') {
        // uniquement si c'est un message visiteur
        if (message.data.auteur === 'Visiteur' && !message.data.read) {
          context.commit('SET_ADD_MESSAGE_ATTENTE', message.data) // mise à jour de la liste des messages en attente
        }
        // si simple agent
      } else {
        // il faut que ce message soit ciblé avec le socketId pour etre ajouté dans la liste de l'agent
        if (message.data.auteur === 'Visiteur' && !message.data.read) {
          if (message.cibleSocketID === context.rootState._StoreWatcheeBox.mySocketID) {
            context.commit('SET_ADD_MESSAGE_ATTENTE', message.data) // mise à jour de la liste des messages en attente
          }
        }
      }
    },
    /**
     * Reception message reseaux sociaux
     * @param  {Object} message [description]
     */
    socket_messageSocialNetwork: (context, message) => {
      // uniquement si l'agent est online ou occupé
      // console.log('context.state.status', context.state.status)
      if (context.state.status !== 'online') {
        // recupere les infos du nouveau visiteur
        // console.log('je suis offline/occupé', message.data)
        context.commit('SET_ADD_MESSAGE_ATTENTE', message.data) // mise à jour de la liste des messages en attente
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js